import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { ElAsyncAutocompleteModule } from '@el-async-autocomplete';
import { ElDataListTableModule } from '@el-data-list-table';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'angular-calendar';

import { MaterialModule } from '../../material.module';
import { SharedModule } from '../shared/shared.module';

import { AddEditRoomsComponent } from './components/add-edit-rooms/add-edit-rooms.component';
import { CalendarBookingComponent } from './components/calendar-booking/calendar-booking.component';
import { MakeABookingComponent } from './components/make-a-booking/make-a-booking.component';
import { BookingErrorPopupComponent } from './components/popups/booking-error-popup/booking-error-popup.component';
import { ReservePopupDialogComponent } from './components/popups/reserve-popup/reserve-popup.component';
import { RoomsComponent } from './components/rooms/rooms.component';
import { RoomsRoutingModule } from './rooms-routing.module';

@NgModule({
  declarations: [
    RoomsComponent,
    AddEditRoomsComponent,
    MakeABookingComponent,
    CalendarBookingComponent,
    ReservePopupDialogComponent,
    BookingErrorPopupComponent,
  ],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    ElDataListTableModule,
    MaterialModule,
    RoomsRoutingModule,
    MatChipsModule,
    CalendarModule,
    MtxDatetimepickerModule,
    ElAsyncAutocompleteModule,
  ],
})
export class RoomsModule {}
